module.exports = __webpack_public_path__ + "img/custom.14bc89bf.svg";